import { memo } from 'react';
import { Outlet } from 'react-router-dom';

function NoneLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}

export default memo(NoneLayout);
